import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, FormGroup, Input, Label, InputGroup, InputGroupText, Button, FormFeedback } from 'reactstrap';
import { H4, P, Image } from '../../../AbstractElements';
import { Lock, User } from 'react-feather';
import { loginUser } from '../../../Services/authService';
import { refreshMenuAfterRoleChange } from '../../../Layout/Sidebar/Menu';
const LoginTab = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setLoading(true);

    try {
      const data = await loginUser(email, password);

      let tokenToStore = null;
      if (data.accessToken) {
        tokenToStore = data.accessToken;
      } else if (data.token) {
        tokenToStore = data.token;
      } else {
        console.warn("Access token not found in login response!");
      }
      if (tokenToStore) {
        localStorage.setItem('accessToken', tokenToStore);
      }

      if (data.fullName) {
        localStorage.setItem('userFullName', data.fullName);
      } else {
        console.warn("User full name not found in login response!");
      }

      if (data.roles && Array.isArray(data.roles) && data.roles.length > 0) {
        const userRole = data.roles[0];
        localStorage.setItem('userRole', userRole);
      } else {
        console.warn("User roles not found or empty in login response!");
        localStorage.setItem('userRole', 'Kullanıcı');
      }

      localStorage.setItem('login', JSON.stringify(true));

      // Refresh menu after successful login
      refreshMenuAfterRoleChange();

      const HOMEPAGE = process.env.REACT_APP_HOMEPAGE || '/dashboard';
      navigate(HOMEPAGE, { replace: true });

    } catch (err) {
      console.error('Login failed:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
      <Form className='theme-form' onSubmit={handleSubmit}>
        <div className='text-center mb-5'>
          <Image attrImage={{ className: 'img-fluid d-inline', src: `${require('../../../assets/images/logo/logo.png')}`, alt: '' }} />
        </div>
        <H4>Giriş Yap</H4>
        <P>{'Email ve şifrenizi girerek giriş yapın.'}</P>
        <FormGroup>
          <Label className='col-form-label'>{'Email'}</Label>
          <InputGroup>
            <InputGroupText><User /></InputGroupText>
            <Input invalid={!!error} className='form-control' type='email' required placeholder='Test@gmail.com' value={email} onChange={(e) => setEmail(e.target.value)} />
          </InputGroup>
        </FormGroup>
        <FormGroup className='position-relative'>
          <Label className='col-form-label'>{'Şifre'}</Label>
          <InputGroup>
            <InputGroupText><Lock /></InputGroupText>
            <Input invalid={!!error} className='form-control' type={show ? 'text' : 'password'} name='login[password]' required placeholder='*********' value={password} onChange={(e) => setPassword(e.target.value)} />
            <div className='show-hide' onClick={() => setShow(!show)}>
              <span className={show ? '' : 'show'}></span>
            </div>
          </InputGroup>
          {error && <FormFeedback style={{ display: 'block' }}>{error}</FormFeedback>}
        </FormGroup>
        <FormGroup>
          <Button color="primary" className="btn btn-block w-100" type="submit" disabled={loading}>
             {loading ? 'Giriş Yapılıyor...' : 'Giriş Yap'}
          </Button>
        </FormGroup>
      </Form>
  );
};

export default LoginTab;
